export default __webpack_public_path__ + "static/media/nc.0a549122.svg";